// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsxRuntime classic */
/* @jsx mdx */
import PostHeader from "@/components/PostHeader";
import Media from "@/components/Media";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PostHeader title='A Tool That Accelerates the Work of Artists!' projectName='Streetwise VidMorpher' imageName='streetwise/login-page.png' date='2023' stack='(ReactJS, Typescript, After Effects, Firebase, Github CI/CD)' order='1' mdxType="PostHeader" />
    <p>{`The project is an extension for After Effects, featuring user management and an easy-to-use workflow.
Users can add data from a spreadsheet and create new versions of videos using a string template.`}</p>
    <div class='blogGallery'>
    <Media src='/work/streetwise/login-page-2.png' alt='streetwise-main-page' mdxType="Media" />
    <Media src='/work/streetwise/workflow-page.png' alt='streetwise-main-page' mdxType="Media" />
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   